/*
 * Copyright (c) 2024-2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {KtsTimingTemplateRow} from './ktsTimingTemplateRow.model';

/**
 * This class is used for repackaging the data for esci to accept. similar to ProgramTiming, but different
 * Can't use ProgramTiming because it has a different structure and would create infinite loop
 */
export class ProgramTimingRow {
    id: number;
    programRunId: number;
    date: Date;
    adjustedWeeks: number;
    ktsTimingTemplateRow: KtsTimingTemplateRow;
    icdsNotOnSchedule: number;
    icdsNotOnScheduleLink: string;

    setProgramTimingRowFromEsciData(row: any) {
        this.id = row.id;
        this.programRunId = row.programRunId;
        if (row.date) {
            this.date = new Date(row.date);
        }
        this.adjustedWeeks = row.adjustedWeeks;
        this.ktsTimingTemplateRow = new KtsTimingTemplateRow(row.ktsTimingTemplateRow, true);
        this.icdsNotOnSchedule = row.icdsNotOnSchedule;
        this.icdsNotOnScheduleLink = row.icdsNotOnScheduleLink;
    }
}
